import { kebabCase } from 'lodash';
export var buildCssInlineSsm = function (css) {
    return Object.keys(css)
        .map(function (key) { return "." + key + "{" + toCssRules(css[key]) + "}"; })
        .join('');
};
function toCssRules(ruleset) {
    var keys = Object.keys(ruleset);
    var validKeys = keys.filter(nonEmptyStringsAndNumbers, ruleset);
    return validKeys.map(function (key) { return kebabCase(key) + ":" + ruleset[key] + ";"; }).join('');
}
function nonEmptyStringsAndNumbers(key) {
    if (typeof this[key] === 'string') {
        return !!this[key];
    }
    return typeof this[key] === 'number';
}
//# sourceMappingURL=build-css-inline-ssm.js.map